import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contract";
import { parallel } from "slotworks/utils/race-utils";


export function HighlightSymbolsCommand(symbols: SymbolComponent[]): Contract<void> {
    const winningSymbolHighlightMethods: Array<() => Contract<void>> = [];

    for (let symbol of symbols) {

        symbol.static();
        
        winningSymbolHighlightMethods.push(() => {
            return symbol.highlight();
        });
    }

    return parallel(winningSymbolHighlightMethods);
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/symbols/highlight-symbols-command.ts